<template>
    <TransactionLog :section="1"></TransactionLog>
</template>

<script>
import TransactionLog from './TransactionLog.vue';
export default {
    components: {
        TransactionLog
    }
};
</script>